<template>
    <template v-if="$store.state.isUserLoggedIn">
        <div ref="switcherRoot" class="position-absolute switch-library-btn companydomain text-xs text-nowrap ps-0" :class="{'marching-ants marching warning': $store.state.support_lib_id !== $store.state.init_support_lib_id}" style="z-index: 9999!important;" v-if="$store.state.support_lib_id == $store.state.init_support_lib_id && !$store.state.parent_lib_id || $store.state.support_lib_id !== $store.state.init_support_lib_id">
            <!-- right-start keeps the arrow on the domain row. Distance/skidding are
                 measured on open so the card's top-left sits on the content panel's
                 top-left, including after the sidebar is resized. -->
            <Popper arrow locked placement="right-start" :offset-distance="String(popperDistance)" :offset-skid="String(popperSkidding)" arrow-padding="12" class="m-0 border-0 w-100" @open:popper="applyZindex()" @close:popper="searchLibrary = '', removeZindex()" >
                <span ref="triggerLabel" class="text-xs position-relative d-flex align-items-center justify-content-between pe-2 cursor-pointer" style="padding-left: 5px!important;" @click="alignPopperToContentPanel">
                    <span class="text-ellipsis" data-bs-toggle="tooltip" data-bs-placement="right" :title="$store.state.library_domain"  @mouseleave="$store.commit('removeToolTip')" style="max-width: 125px;">
                        {{ $store.state.library_domain }}
                    </span> 
                    <i class="fa-regular text-xs fa-chevron-down cursor-pointer"></i>
                </span>
                <template #content="{ close }">
                    <div class="popover-content inbox-nav-manage-options library-switch-popover bg-white shadow p-2 cursor-pointer"
                        ref="popoverContent" style="min-width: 260px; max-width: 300px">
                        <div class="container-fluid p-0">
                            <div class="d-flex align-items-center p-1">
                                <input class="form-control noshadow flex-grow-1 text-xs mb-0" placeholder="Search"
                                    v-model="searchLibrary" style="display: block;" v-if="$store.state.support_lib_id == $store.state.init_support_lib_id">
                            </div>
                            <div v-if="$store.state.support_lib_id !== $store.state.init_support_lib_id"  class="p-2 d-flex align-items-center justify-content-between active btn btn-light  m-0">
                                <span class="text-xs cursor-pointer" @click="logoutAs(); close()"><i class="fa-solid fa-turn-left me-2" style="color: var(--mi-chat-primary-color);"></i> Switch back to my account</span>
                            </div>
                            <ul class="list-unstyled text-sm p-2 px-1 mb-0 popli pb-3"
                                style=" max-height: 400px; overflow-y: auto;">
                                <li class="p-2 d-flex align-items-center justify-content-between cursor-pointer" v-for="library, index in childLibraryList.filter(el => el.library_domain.toLowerCase().includes(searchLibrary.toLowerCase()))"
                                    :key="index" @click="loginAs(library, close)">
                                    <div class="d-flex align-items-center" >
                                        <span class="text-xs">{{ library.library_domain }}</span>
                                    </div>
                                </li>
                                <li class="p-2 d-flex align-items-center justify-content-between cursor-pointer" v-if="childLibraryList.filter(el => el.library_domain.toLowerCase().includes(searchLibrary.toLowerCase())).length == 0">
                                    <div class="d-flex align-items-center">
                                        <span class="text-xs">No libraries found</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </Popper>
        </div>
        <div v-else style="max-width: 125px;" data-bs-toggle="tooltip" data-bs-placement="right" :title="$store.state.library_domain"  @mouseleave="$store.commit('removeToolTip')" class="position-absolute text-xs rounded text-xs companydomain text-nowrap text-ellipsis" :key="$store.state.library_domain">
            {{ $store.state.library_domain }}
        </div>
    </template>
</template>
<script>
import moment from 'moment';
import Api from '@/api/Api';
import { getBaseUrls } from '@/utils/getBaseUrls';
import firebase from 'firebase/app';
import axios from 'axios';
const {inboxBaseURL} = getBaseUrls();
export default {
    name: 'DomainLabel',
    data() {
        return {
            user_type: localStorage.getItem('user_type'),
            searchLibrary: '',
            popperDistance: 22,
            popperSkidding: 0,
        }
    },
    methods: {
        // The sidebar this instance is rendered in. Reports and Settings each build
        // their own host, and querying the document took whichever came first rather
        // than the one holding the panel that needs to come forward.
        switcherHost() {
            return this.$refs.switcherRoot ? this.$refs.switcherRoot.closest('.modal-chat-inbox') : null;
        },
        // The white card the domain row sits in.
        sidebarCard() {
            const root = this.$refs.switcherRoot;
            return root ? root.closest('.inbox-nav') || this.switcherHost() : null;
        },
        // The agency list lines up with the content card beside the sidebar. Reading
        // that card off the DOM is unreliable — on the builder pages the sidebar's
        // next sibling is a zero-height wrapper starting at the sidebar's own left
        // edge, which pulled the list back over the sidebar. Every page lays the two
        // cards out the same way instead: same top, one panel gutter apart.
        alignPopperToContentPanel() {
            // Popper offsets everything from the node it wraps the default slot in,
            // which is inset from the domain row by the row's own padding, so the
            // row's rect is the wrong thing to measure against.
            const reference = this.$refs.triggerLabel?.parentElement;
            const card = this.sidebarCard();
            if (!reference || !card) {
                return;
            }
            const referenceRect = reference.getBoundingClientRect();
            const cardRect = card.getBoundingClientRect();
            const gutter = parseFloat(getComputedStyle(card).getPropertyValue('--mi-newui-panel-gutter')) || 10;
            this.popperDistance = Math.max(0, Math.round(cardRect.right + gutter - referenceRect.right));
            this.popperSkidding = Math.round(cardRect.top - referenceRect.top);
        },
        applyZindex() {
            this.alignPopperToContentPanel();
            const element = this.switcherHost();
            if(element) {
                // Under .app-main-nav's 99999. Matching it tied, and this host comes
                // later in the document, so the panel painted over the expanded nav.
                element.style.zIndex = '9998';
                element.style.setProperty('overflow', 'visible', 'important');
            }
            // The domain label's own tooltip opens to the right and lands on the
            // search field. Dismiss it once the agency list is up.
            this.$store.commit('removeToolTip');
        },
        removeZindex() {
            const element = this.switcherHost();
            if(element) {
                // Drop the override instead of writing `auto`, which outranks the
                // stylesheet's z-index: 100 and leaves the sidebar under the page.
                element.style.removeProperty('z-index');
                element.style.removeProperty('overflow');
            }
        },
        async regenerateToken(support_lib_id) {
            const getFreshToken = async () => {
                const user = firebase.auth().currentUser;
                if (user) {
                    return await user.getIdToken(true);
                } else {
                    throw new Error('No user is signed in.');
                }
            };
            let loginToken = '';
            await getFreshToken().then(token => {
                // console.log('Fresh Token:', token)
                loginToken = token;
            })
            let payload = {
                email: localStorage.getItem('user_email'),
                user_id: localStorage.getItem('user_id'),
                support_lib_id: support_lib_id,
            };
            let res = await axios.post(`${inboxBaseURL}/login`, payload, {
                headers: {
                    Authorization: `Bearer ${loginToken}`,
                },
            });
            if (res?.data?.token) {
                localStorage.setItem('inbox-chat-token', res.data.token);
            }
        },
        async loginAs(event, close) {
            close();
            if(event.support_lib_id == this.$store.state.support_lib_id) {
                return;
            }
            this.$store.state.isLibrarySwitching = true;
            const loginpayload = {
                admin_support_lib_id: event.support_lib_id
            }
            try {
                await Api.loginAs(loginpayload).then(async (res) => {
                    // console.log('success while logging in', res);
                    // await this.login(res)
                    localStorage.setItem('support_Lib_id', res?.data?.data?.admin_support_lib_id);
                    await this.regenerateToken(res?.data?.data?.admin_support_lib_id);
                    close();
                    this.$store.state.showToast = {
                        icon: 'fa fa-check',
                        title: 'Success',
                        description: 'You have been logged in as ' + event.library_domain + ', reloading the page...',
                        time: moment().valueOf(),
                    }
                    this.$store.state.removeEventListeners = !this.$store.state.removeEventListeners
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000)

                })
            }
            catch (err) {
                console.log('err while logging in', err);
                this.$store.state.showToast = {
                    icon: 'fa fa-exclamation-triangle',
                    title: 'Error',
                    description: 'An error occurred while logging in',
                    time: moment().valueOf(),
                }
            } finally {
                setTimeout(() => {
                    this.$store.state.isLibrarySwitching = false;
                }, 1000)
            };


        },
        async logoutAs() {
            this.$store.state.isLibrarySwitching = true;
            const payload = {
                action: "logoutas",
                admin_support_lib_id: this.$store.state.support_lib_id,
            }
            try {
                await Api.logoutAs(payload).then(async (res) => {
                    const init_support_lib_id = localStorage.getItem('init_support_lib_id');
                    localStorage.setItem('support_Lib_id', init_support_lib_id);
                    localStorage.removeItem('parent_lib_id');
                    await this.regenerateToken(init_support_lib_id);
                    this.$store.state.showToast = {
                        icon: 'fa fa-check',
                        title: 'Success',
                        description: 'You have been logged out, reloading the page...',
                        time: moment().valueOf(),
                    }
                    this.$store.state.removeEventListeners = !this.$store.state.removeEventListeners
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000)
                })
            } catch (err) {
                console.log('err while logging out', err);
                this.$store.state.showToast = {
                    icon: 'fa fa-exclamation-triangle',
                    title: 'Error',
                    description: 'An error occurred while logging out',
                    time: moment().valueOf(),
                }
            } finally {
                setTimeout(() => {
                    this.$store.state.isLibrarySwitching = false;
                }, 1000)
            }
        },
        parent_lib_id() {
            return localStorage.getItem('parent_lib_id');
        },
        init_support_lib_id() {
            return localStorage.getItem('init_support_lib_id');
        },
        default_support_lib_id() {
            return process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID;
        },
        getDomain() {
            return localStorage.getItem('library_domain');
        },
    },
    computed: {
        childLibraryList() {
            if(this.$store.state.support_lib_id !== this.$store.state.init_support_lib_id) {
                return [{
                    library_domain: this.$store.state.library_domain,
                    support_lib_id: this.$store.state.support_lib_id,
                }];
            }
            return this.$store.state.childLibraryList;
        },
    },
}
</script>
<style>
/* Popper's own arrow, aimed at the middle of the domain row. vue3-popper
   leaves the arrow fill on an unset theme variable, and on hover swaps it for
   another unset one, so the head vanished or turned into a hollow diamond.
   A border on every side drew that diamond; only the two edges that form the
   left-pointing tip should show. The card sits above the arrow so the inner
   half is covered and what remains is the pointer. */
.switch-library-btn .popper {
    --popper-theme-background-color: var(--mi-chat-white-color, #fff);
    --popper-theme-background-color-hover: var(--mi-chat-white-color, #fff);
    --popper-theme-border-width: 0px;
    --popper-theme-padding: 0px;
    z-index: 10000;
}
.switch-library-btn .popper > #arrow,
.switch-library-btn .popper > #arrow::before {
    width: 12px !important;
    height: 12px !important;
}
.switch-library-btn .popper[data-popper-placement^="right"] > #arrow {
    left: -6px !important;
}
.switch-library-btn .popper > #arrow {
    z-index: 0;
}
.switch-library-btn .popper > #arrow::before,
.switch-library-btn .popper:hover > #arrow::before {
    background: var(--mi-chat-white-color, #fff) !important;
    border-style: solid !important;
    border-color: var(--mi-chat-secondary-bg-color) !important;
    border-width: 0 !important;
}
.switch-library-btn .popper[data-popper-placement^="right"] > #arrow::before,
.switch-library-btn .popper[data-popper-placement^="right"]:hover > #arrow::before {
    border-left-width: 1px !important;
    border-bottom-width: 1px !important;
}
/* `.inbox-nav-manage-options` is shared with the icon rail's popovers, which are
   nudged by a hardcoded `top: -60px; left: 130px` inside #modal-chat-inbox. That
   pulled this card away from its own arrow on the Inbox page only, leaving the
   arrow stranded at the sidebar edge. Popper already places the card. */
#modal-chat-inbox .switch-library-btn .popover-content.inbox-nav-manage-options,
.switch-library-btn .popover-content {
    position: relative;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    margin: 0 !important;
    z-index: 1;
    background: var(--mi-chat-white-color, #fff);
    box-shadow: 0 8px 24px rgba(32, 40, 77, 0.12);
}
.switch-library-btn .list-unstyled li {
    border-radius: 8px;
}
.switch-library-btn .list-unstyled li:hover {
    background-color: var(--mi-chat-primary-bg-color) !important;
    border-radius: 8px !important;
}
.switch-library-btn .list-unstyled {
    overflow-x: hidden!important;
}
.marching-ants {
  background-size: 10px 2px, 10px 2px, 2px 10px, 2px 10px;
  background-position: 0 0, 0 100%, 0 0, 100% 0;
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  -webkit-animation: marching-ants-1 1s;
          animation: marching-ants-1 1s;
  -webkit-animation-timing-function: linear;
          animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
  -webkit-animation-play-state: paused;
          animation-play-state: paused;
}
.marching-ants.reverse {
  animation-direction: reverse;
}
.marching-ants.warning {
  background-size: 5px 1px, 5px 1px, 1px 5px, 1px 5px;
  background-position: 0 0, 0 100%, 0 0, 100% 0;
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  -webkit-animation: marching-ants-2 2s;
          animation: marching-ants-2 2s;
  -webkit-animation-timing-function: linear;
          animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
  -webkit-animation-play-state: paused;
          animation-play-state: paused;
  background-image: linear-gradient(to right, #0400FE 50%, #fff 50%), linear-gradient(to right, #0400FE 50%, #fff 50%), linear-gradient(to bottom, #0400FE 50%, #fff 50%), linear-gradient(to bottom, #0400FE 50%, #fff 50%);
  color: #a00;
  background-color: #faa;
}
.marching-ants.warning:hover, .marching-ants.warning.marching {
  -webkit-animation-play-state: running;
          animation-play-state: running;
}
.marching-ants.warning.reverse {
  animation-direction: reverse;
}

@-webkit-keyframes marching-ants-1 {
  0% {
    background-position: 0 0, 0 100%, 0 0, 100% 0;
  }
  100% {
    background-position: 40px 0, -40px 100%, 0 -40px, 100% 40px;
  }
}

@keyframes marching-ants-1 {
  0% {
    background-position: 0 0, 0 100%, 0 0, 100% 0;
  }
  100% {
    background-position: 40px 0, -40px 100%, 0 -40px, 100% 40px;
  }
}
@-webkit-keyframes marching-ants-2 {
  0% {
    background-position: 0 0, 0 100%, 0 0, 100% 0;
  }
  100% {
    background-position: 40px 0, -40px 100%, 0 -40px, 100% 40px;
  }
}
@keyframes marching-ants-2 {
  0% {
    background-position: 0 0, 0 100%, 0 0, 100% 0;
  }
  100% {
    background-position: 40px 0, -40px 100%, 0 -40px, 100% 40px;
  }
}
@-webkit-keyframes marching-ants-3 {
  0% {
    background-position: 0 0, 0 100%, 0 0, 100% 0;
  }
  100% {
    background-position: 40px 0, -40px 100%, 0 -40px, 100% 40px;
  }
}
@keyframes marching-ants-3 {
  0% {
    background-position: 0 0, 0 100%, 0 0, 100% 0;
  }
  100% {
    background-position: 40px 0, -40px 100%, 0 -40px, 100% 40px;
  }
}

.switch-library-btn .list-unstyled {
    -ms-overflow-style: none;     /* IE, Edge (legacy) */
    scrollbar-width: none;     
}

.switch-library-btn .list-unstyled::-webkit-scrollbar {
  width: 0px;  /* Chrome, Safari, Opera */
  height: 0px; /* for horizontal scrollbar */
} 

.switch-library-btn .popover-content {
   border: 1px solid var(--mi-chat-secondary-bg-color);
   border-radius: var(--mi-newui-card-radius, 12px);
}

.switch-library-btn .popper {
    border-radius: var(--mi-newui-card-radius, 12px)!important;
}

</style>